import * as _ from 'lodash'
import axios from 'axios'
import {PAEnvironment} from "./PAEnvironment";
import {IEntityService, IEntityServiceRecordProperties, ISchema} from "./PA.Core.IF.Entity";
import {IwbCustomColumn} from "./PAdbSchemaRowsIF";

export interface IEntityRequest {
  requestType:       string,
  wbConnectionId?:   number,
  entityName?:       string,
  entityColumnName?: string,
  wbSubjectAreaId?:  number,
  appManagerId?:     string,
  wbAppId?:          number,
  recordProperties?: IEntityServiceRecordProperties,
  options?:          any
}

export interface IEntityResponse {
  request: IEntityRequest,
  bError: boolean,
  sErrors: string[],
  results: any
}

export class PAEntity
  implements IEntityService
{
  constructor(){

  }

  checkEntityColumnExists(aWB_Connection_ID: number, sEntityName: string, sColumnName: string, options?: { sEntityType?: string }): Promise<boolean> {
    return PAEntity.makeRequest("checkEntityColumnExists", aWB_Connection_ID, sEntityName, sColumnName, 0, undefined, undefined, undefined, options || {});
  }

  checkEntityExists(aWB_Connection_ID: number, sEntityName: string, options?: { sEntityType?: string }): Promise<boolean> {
    return PAEntity.makeRequest("checkEntityExists", aWB_Connection_ID, sEntityName, undefined, 0,undefined, undefined, undefined, options);
  }


  getEntityColumnList(aWB_Connection_ID: number, sEntityName: string): Promise<string[]> {
    return PAEntity.makeRequest("getEntityColumnList", aWB_Connection_ID, sEntityName, undefined, 0, undefined, undefined, undefined, undefined);
  }

  getEntityList(aWB_Connection_ID: number, options?: { sEntityType?: string; sPrefix?: string; sContains?: string }): Promise<string[]> {
    return PAEntity.makeRequest("getEntityList", aWB_Connection_ID, undefined, undefined, 0, undefined, undefined, undefined, options || {});
  }

  getEntitySchema(aWB_Connection_ID: number, sEntityName: string, options?: { sEntityType?: string }): Promise<ISchema> {
    return PAEntity.makeRequest("getEntitySchema", aWB_Connection_ID, sEntityName, undefined, 0, undefined, undefined, undefined, options || {});
  }

  getSQLSchema(aWB_Connection_ID: number, sSql: string, options?: {}): Promise<ISchema> {
    return PAEntity.makeRequest("getSQLSchema", aWB_Connection_ID, sSql, undefined, 0, undefined, undefined, undefined, options || {});
  }

  checkSubjectAreaExists(aWB_SubjectArea_ID: number): Promise<boolean> {
    return PAEntity.makeRequest("checkSubjectAreaExists", undefined, undefined, undefined, aWB_SubjectArea_ID, undefined, undefined, undefined, undefined);
  }

  syncSubjectArea(aWB_SubjectArea_ID: number): Promise<void> {
    return PAEntity.makeRequest("syncSubjectArea", undefined, undefined, undefined, aWB_SubjectArea_ID, undefined, undefined, undefined, undefined);
  }

  invalidateConnection(aWB_Connection_ID: number): Promise<void> {
    return PAEntity.makeRequest("invalidateConnection", aWB_Connection_ID, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }

  checkCustomColumnExists(aAppMgr_Id: string, aWB_App_Id: number, aTable_Name: string, aColumn_Name: string): Promise<boolean> {
    // Add missing parameters (aAppMgr_Id, aWB_App_Id)
    return PAEntity.makeRequest("checkCustomColumnExists", undefined, aTable_Name, aColumn_Name, undefined, aAppMgr_Id, aWB_App_Id, undefined, undefined);
  }

  createOrUpdateCustomColumn(aAppMgr_Id: string, aWB_App_Id: number, aTable_Name: string, aColumn_Name: string, recordProperties: IEntityServiceRecordProperties): Promise<IwbCustomColumn> {
    return PAEntity.makeRequest("createOrUpdateCustomColumn", undefined, aTable_Name, aColumn_Name, undefined, aAppMgr_Id, aWB_App_Id, recordProperties, undefined);
  }

  getCustomColumn(aAppMgr_Id: string, aWB_App_Id: number, aTable_Name: string, aColumn_Name: string): Promise<IwbCustomColumn> {
    return PAEntity.makeRequest("getCustomColumn", undefined, aTable_Name, aColumn_Name, undefined, aAppMgr_Id, aWB_App_Id, undefined, undefined);
  }

  //
  private static makeRequest(requestType: string,
                             wbConnectionId: number,
                             entityName: string,
                             entityColumnName: string,
                             wbSubjectAreaId: number,
                             appMgrId: string,
                             wbAppId: number,
                             recordProperties: IEntityServiceRecordProperties,
                             options: any): Promise<any>
  {
    return new Promise<any[]>((resolve, error) => {


      let entityRequest: IEntityRequest = {
        requestType: requestType
      }

      if(wbConnectionId)
        entityRequest.wbConnectionId = wbConnectionId

      if(appMgrId)
        entityRequest.appManagerId = appMgrId

      if(wbAppId)
        entityRequest.wbAppId = wbAppId

      if(recordProperties)
        entityRequest.recordProperties = recordProperties

      if(entityName)
        entityRequest.entityName = entityName

      if(entityColumnName)
        entityRequest.entityColumnName = entityColumnName

      if(wbSubjectAreaId)
        entityRequest.wbSubjectAreaId = wbSubjectAreaId

      if(options)
        entityRequest.options = options

      let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base,"/"));
      if(sEndPoint.endsWith('/'))
        sEndPoint += 'entity';
      else
        sEndPoint += '/entity';

      axios.post(sEndPoint, {data: {request: entityRequest}})
        .then((resp: any) => {
          let responseData: IEntityResponse = resp.data;
          if('request' in responseData) {
            if(responseData.bError){
              error("Entity Service Response: " + (responseData.sErrors || ['Unknown']).toString())
            } else {
              resolve(responseData.results)
            }
          } else {
            error('Unable to parse Entity Web Response: ' + responseData );
          }
        })
        .catch((err:any) => {
          error('Unable to obtain Entity Results from Server. ' + err);
        });
    });
  }


}

